import { rewardToWei } from "../../../utils"

const txObj = (address, args) => {
    args.from = address
    // gasPrice = (await avgGasPrice()) + 200000000000 // Added 200 gwei
    return args
}

const approve = async (web3, ERC20, payment, ownerAddress, selectedProduct, setProcessing, setMessage, setAllowed) => {
    let tokenContract
    let paymentContract
    try {
        tokenContract = new web3.eth.Contract(ERC20, selectedProduct.paymentToken)
        paymentContract = new web3.eth.Contract(payment.contractAbi, payment.contractAddress)
    } catch (error) {
        setMessage("error", "Error initializing contract")
        console.log(error)
    }
    if (tokenContract && paymentContract) {
        try {
            setProcessing(true)
            let balanceInWei = await tokenContract.methods.balanceOf(ownerAddress).call()
            console.log(balanceInWei)

            let approveAmountInWei = selectedProduct.price
            if (Number(approveAmountInWei) <= Number(balanceInWei)) {
                let allowedInWei = await tokenContract.methods.allowance(ownerAddress, payment.contractAddress).call()
                if (Number(allowedInWei) < Number(approveAmountInWei)) {
                    await tokenContract.methods
                        .approve(payment.contractAddress, approveAmountInWei)
                        .send(txObj(ownerAddress, payment.args))
                        .on("receipt", function (receipt) {
                            if (receipt.status === true) {
                                setAllowed(approveAmountInWei)
                                setMessage("success", `Approved successfully.`)
                                setProcessing(false)
                            } else {
                                setMessage("error", "Approve fail")
                                setProcessing(false)
                            }
                        })
                        .on("error", function (error) {
                            setMessage("error", error.message)
                            setProcessing(false)
                        })
                } else {
                    setMessage(
                        "info",
                        `Amount already approved for this contract: ${web3.utils.fromWei(allowedInWei, "ether")} ${selectedProduct.paymentSymbol}`
                    )
                }
                setProcessing(false)
            } else {
                setMessage("info", "Amount must be equal to or less than balance!")
            }
        } catch (error) {
            console.log(error)
            setProcessing(false)
        }
    } else {
        console.log("Uninitialized Contracts")
    }
    setProcessing(false)
}

const payProduct = async (web3, ERC20, payment, ownerAddress, selectedProduct, setProcessing, setMessage) => {
    let tokenContract
    let paymentContract
    try {
        tokenContract = new web3.eth.Contract(ERC20, selectedProduct.paymentToken)
        paymentContract = new web3.eth.Contract(payment.contractAbi, payment.contractAddress)
    } catch (error) {
        setMessage("error", "Error initializing contract")
        console.log(error)
    }

    if (tokenContract && paymentContract) {
        try {
            setProcessing(true)
            let balanceInWei = await tokenContract.methods.balanceOf(ownerAddress).call()

            await paymentContract.methods
                .payProduct(selectedProduct.productId)
                .send(txObj(ownerAddress, payment.args))
                .on("receipt", function (receipt) {
                    if (receipt.status === true) {
                        //  setAllowance(allowance - amount)
                        setProcessing(false)
                        setMessage("success", `Purchased successfully`)
                        // onSuccess()
                    } else {
                        setMessage("error", "Purchase fail")
                        setProcessing(false)
                    }
                })
                .on("error", function (error) {
                    setMessage("error", error.message)
                    setProcessing(false)
                })

            setProcessing(false)
        } catch (error) {
            console.log(error)
            setProcessing(false)
        }
    } else {
        console.log("Uninitialized Contracts")
    }
    setProcessing(false)
}

export { approve, payProduct }
